<template lang="pug">
RouterLink.deal-link(:to=" '/deals/' + camelizedDeal.id " :target="props.target") 
  template(v-if="slots.default")
    slot
  template(v-else)
    template(v-if="camelizedDeal.fullName")
      span {{ camelizedDeal.fullName }}
    template(v-else)
      span {{ camelizedDeal.firstName }} {{ camelizedDeal.lastName }}  
  //- pre {{ camelizedDeal }}
</template>

<script setup>
import { useSlots, computed } from 'vue'
import { RouterLink } from 'vue-router'
import { utils } from '@/utils'

const slots = useSlots()

const props = defineProps({
  deal: {
    type: Object,
    default: {},
  },
  target: {
    type: String,
    default: null,
  },
})

// this allows this component to work whether the props.deal has camelized json keys or regular/underscore
const camelizedDeal = computed(() => utils.camelizeKeysDeep(props.deal))
</script>